import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { API_BASE_URL } from '../utils/songUtils';
import SongListItem from './SongListItem';

const SectionContainer = styled.div`
  margin: 50px 0;
  width: 100%;
  box-sizing: border-box;
  opacity: ${props => props.$visible ? 1 : 0};
  transform: translateY(${props => props.$visible ? '0' : '-20px'});
  transition: opacity 0.3s ease-out, transform 0.3s ease-out;
  position: ${props => props.$visible ? 'relative' : 'absolute'};
  top: 0;
  left: 0;
  right: 0;

  @media (min-width: 769px) and (max-width: 1280px) {
    padding: 0 15px;
  }

  @media (max-width: 768px) {
    padding: 0 15px;
  }
`;

const SectionTitle = styled.h2`
  font-family: 'DM Serif Text', serif;
  color: #2E2E2E;
  margin-bottom: 30px;
  text-align: left;

  @media (max-width: 768px) {
    text-align: center;
  }
`;

const SongsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
`;

const LoadingContainer = styled.div`
  padding: 20px;
  text-align: center;
  color: #2E2E2E;
  font-size: 16px;
`;

const ErrorContainer = styled.div`
  padding: 20px;
  text-align: center;
  color: #ff4444;
  font-size: 16px;
`;

function NewStockSection({ visible = true }) {
  const [newSongs, setNewSongs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchNewSongs = async () => {
      try {
        setLoading(true);
        setError(null);
        
        console.log('Fetching songs from:', `${API_BASE_URL}/songs`); // Debug log
        
        const response = await fetch(`${API_BASE_URL}/songs`);
        console.log('Response status:', response.status); // Debug log
        
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const songs = await response.json();
        console.log('Fetched songs:', songs.length); // Debug log
        
        // Sort songs by date_added in descending order (newest first)
        const sortedSongs = songs
          .sort((a, b) => new Date(b.date_added) - new Date(a.date_added))
          .slice(0, 25); // Get only the 25 newest songs
        
        setNewSongs(sortedSongs);
      } catch (error) {
        console.error('Error fetching songs:', error);
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchNewSongs();
  }, []);

  if (loading) {
    return (
      <SectionContainer $visible={visible}>
        <SectionTitle>New stock</SectionTitle>
        <LoadingContainer>
          Loading new tracks...
        </LoadingContainer>
      </SectionContainer>
    );
  }

  if (error) {
    return (
      <SectionContainer $visible={visible}>
        <SectionTitle>New stock</SectionTitle>
        <ErrorContainer>
          Error loading new tracks. Please try again later.
        </ErrorContainer>
      </SectionContainer>
    );
  }

  if (newSongs.length === 0) {
    return (
      <SectionContainer $visible={visible}>
        <SectionTitle>New stock</SectionTitle>
        <LoadingContainer>
          No new tracks available at the moment.
        </LoadingContainer>
      </SectionContainer>
    );
  }

  return (
    <SectionContainer $visible={visible}>
      <SectionTitle>New stock</SectionTitle>
      <SongsList>
        {newSongs.map((song) => (
          <SongListItem 
            key={song.song_id} 
            song={song}
            shouldTrackPlay={false}
          />
        ))}
      </SongsList>
    </SectionContainer>
  );
}

export default NewStockSection; 